<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>NavAids Import Options</h2>
      <div class="close" (click)="cancelImport()"><img src="/assets/img/close-white.svg" alt="" /></div>

      <div class="fields__container">
        <form autocomplete="off"  name="ngImportCsvForm" #ngForm="ngForm" id="importCsvForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Configured Fields To Import</h4>
                <span> </span>
              </div>
              <div class="table-fields">
                <div style="overflow-y: scroll; height: 237px;">
                  <table>
                    <caption>
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">Use</th>
                        <th scope="col">Name</th>
                        <th scope="col">Index</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr mdbTableCol *ngFor="let el of navAidsImportCsvModel.table; let i = index">
                        <td>
                          <input id="chk_{{i}}" name="chk_{{i}}"
                           type="checkbox" [(ngModel)]="el.checked" [disabled]="el.required ? true : false"/>
                        </td>
                        <td>{{ el.name }}</td>
                        <td>
                          <input id="index_{{i}}" required="true"
                          name="index_{{i}}"
                          [(ngModel)]="el.index" value="el.index"/>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="input-fields">
                <div>
                  <label for="">Data Starting Line</label>
                  <input
                    style="max-width: 112px;"
                    maxlength="5"
                    [(ngModel)]="navAidsImportCsvModel.dataStartingLine"
                    type="number"
                    name="dataStartingLine"
                    id="dataStartingLine"
                  />
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Field Separator</label>
                  <select
                      name="fieldSeparator"
                      [(ngModel)]="navAidsImportCsvModel.fieldSeparator"
                    >
                      <option value=".">Dot (.)</option>
                      <option value=",">Comma (,)</option>
                      <option value=";">Semicolon (;)</option>
                      <option value="\t">Tab</option>
                      <option value=" ">Space</option>
                    </select>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Decimal Separator</label>
                  <select
                      name="decimalSeparator"
                      [(ngModel)]="navAidsImportCsvModel.decimalSeparator"
                    >
                      <option value=".">Dot (.)</option>
                      <option value=",">Comma (,)</option>
                      <option value=";">Semicolon (;)</option>
                    </select>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Country Code Type</label>
                  <select style="min-width: 112px;"
                      name="countryCoteType"
                      [(ngModel)]="navAidsImportCsvModel.countryCoteType"
                    >
                      <option value="ICAO">ICAO</option>
                      <option value="ITU">ITU</option>
                    </select>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">File Data Source</label>
                  <select
                      style="max-width: 112px;"
                      name="fileDataSource"
                      [(ngModel)]="navAidsImportCsvModel.fileDataSource"
                    >
                      <option value="Published">Published</option>
                      <option value="UserDefined">User Defined</option>
                    </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>CSV Source File</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">File</label>
                  <input
                  style="padding-left: 0px;"
                    maxlength="300"
                    type="file"
                    name="filename"
                    id="filename"
                    (change)="saveFile($event)"
                    [accept]="importFormat.fileExtension"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="startImport();" [disabled]="!ngForm.form.valid">
              Import
            </button>
            <button class="gray" (click)="cancelImport()">Cancel</button>
          </div>
        </form>

      </div>

    </div>
  </div>
</div>
